import React from 'react';
import { Panel, Button, Message } from 'rsuite';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
			errorInfo: null
		};
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error('ErrorBoundary caught an error:', error, errorInfo);
		this.setState({
			error,
			errorInfo
		});
	}

	handleReset = () => {
		this.setState({
			hasError: false,
			error: null,
			errorInfo: null
		});
	};

	render() {
		if (this.state.hasError) {
			return (
				<div className="error-boundary-container" style={{ padding: '20px' }}>
					<Panel
						bordered
						header={
							<div style={{ color: '#d32f2f', fontWeight: 'bold' }}>
								Something went wrong
							</div>
						}
					>
						<Message showIcon type="error">
							<strong>Error:</strong> {this.state.error?.toString()}
						</Message>

						{process.env.NODE_ENV === 'development' && (
							<div style={{ marginTop: '20px' }}>
								<details style={{ whiteSpace: 'pre-wrap' }}>
									<summary style={{ cursor: 'pointer', marginBottom: '10px' }}>
										<strong>Error Details</strong>
									</summary>
									{this.state.errorInfo?.componentStack}
								</details>
							</div>
						)}

						<div style={{ marginTop: '20px' }}>
							<Button
								appearance="primary"
								onClick={this.handleReset}
								style={{ marginRight: '10px' }}
							>
								Try Again
							</Button>
							<Button
								appearance="subtle"
								onClick={() => window.location.reload()}
							>
								Reload Page
							</Button>
						</div>
					</Panel>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
